<template>
  <vs-popup class="customer-site-create-popup" background-color-popup="danger" background-color="danger" title="DOCUMENTS"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <vs-table noDataText="" v-if="work_orders.length > 0 || courier_shipments.length > 0 || fg_documents.length > 0">

        <template slot="thead">
          <vs-th width="50%"></vs-th>
          <vs-th width="50%">Action</vs-th>
        </template>
        <template slot-scope="{data}">
          <small v-if="work_orders.length > 0" class="ml-1 font-bold">COA</small>
          <vs-tr v-if="work_orders.length > 0" v-for="(wo, index) in work_orders" :key="`wo_${index}`">
            <vs-td>{{ wo.work_order_code }}</vs-td>
            <vs-td>
              <vs-button @click="onClickPrint(wo.id)" class="ml-2" size="small" color="warning" type="border"
                icon-pack="feather" icon="icon-printer">
                view
              </vs-button>
            </vs-td>
          </vs-tr>
          <small v-if="courier_shipments.length > 0" class="ml-1 font-bold">shipments</small>
          <vs-tr v-if="courier_shipments.length > 0" v-for="(shipment, index) in courier_shipments" :key="`shipment_${index}`">
            <vs-td>{{ shipment.courier_shipment_code }}</vs-td>
            <vs-td>
              <vs-button @click="onClickViewShipment(shipment.id)" class="ml-2" size="small" color="warning" type="border"
                icon-pack="feather" icon="icon-printer">
                view
              </vs-button>
            </vs-td>
          </vs-tr>
          <small v-if="fg_documents.length > 0" class="ml-1 font-bold">product documents</small>
          <vs-tr v-if="fg_documents.length > 0" v-for="(doc, index) in fg_documents" :key="`doc_${index}`">
            <vs-td>{{ doc.name }}</vs-td>
            <vs-td>
              <div class="vx-row ml-1">
                <vs-button v-for="(button, index_button) in doc.files" :key="`doc_${index}_button_${index_button}`" class="ml-1 mb-1" size="small" color="warning" type="border"
                  icon-pack="feather" icon="icon-printer" @click.stop="onClickViewDoc(button)">
                    view
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div v-else>No documents available</div>

    </vx-card>
    <ProductOrderCofaDocumentPopUp ref="productOrderCofaDocumentPopUp" />
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import ProductOrderCofaDocumentPopUp from './ProductOrderCofaDocumentPopUp.vue'

function initialState() {
  return {
    open: false,
    work_orders: [],
    formulation_type: '',
    courier_shipments: [],
    fg_documents: []
  }
}

export default {
  name: 'ProductOrderDocumentsPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(formulation_type, wo_arr, courier_shipments, fg_documents) {
      try {
        await Object.assign(this.$data, initialState())
        this.work_orders = wo_arr
        this.courier_shipments = courier_shipments
        this.formulation_type = formulation_type
        this.fg_documents = fg_documents ? fg_documents.documentation : []
        this.open = true;
      } catch (error) {

      }
    },
    onClickPrint(wo_id) {
      this.$refs.productOrderCofaDocumentPopUp.openPopup(wo_id, this.formulation_type)
    },
    onClickViewShipment(shipment_id) {
      window.open(`/files/shipment/${shipment_id}`, '_blank')
    },
    onClickViewDoc(file){
      window.open(file, '_blank')
    }
  },
  async mounted() {

  },
  components: {
    'v-select': vSelect,
    ProductOrderCofaDocumentPopUp
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.customer-site-create-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}
</style>
